import React, { PureComponent } from 'react';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import config from '../../../config';
import {withTranslation} from "react-i18next";

class LogInForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.state = {
      showPassword: false,
    };
  }

  showPassword = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  };

  render() {
    const {t} = this.props;
    return (
      <form className="form">
        <a className="btn btn-danger account__btn account__btn--small" href={config.AUTH_ADDRESS}>{t('login.login_with_steemconnect')}</a>
      </form>
    );
  }
}

export default reduxForm({
  form: 'log_in_form',
})(withTranslation('dashboard')(LogInForm));
